<template>
  <div>
    <page-section bgcolor="bg-gray-50">
      <section-heading pre="Resources">Useful Links</section-heading>
      <div class="bg-white shadow overflow-hidden sm:rounded-md">
        <ul class="divide-y divide-gray-200">
          <li v-for="(resource, i) in resources" :key="i">
            <a
              :href="resource.to"
              target="_blank"
              class="block hover:bg-gray-50"
            >
              <div class="px-4 py-4 flex items-center sm:px-6">
                <div
                  class="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between"
                >
                  <div class="">
                    <div class="flex text-sm">
                      <p
                        class="font-medium text-green font-extrabold mt-4 mb-2"
                      >
                        {{ resource.title }}
                      </p>
                    </div>
                    <div class="flex">
                      <div class="flex items-center text-sm text-gray-500">
                        <p class="mb-2">{{ resource.description }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ml-5 flex-shrink-0">
                  <svg
                    class="-mr-1 ml-3 h-5 w-5 text-gray-400"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"
                    />
                    <path
                      d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"
                    />
                  </svg>
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </page-section>
  </div>
</template>
<script>
import SectionHeading from "@/components/SectionHeading";
import PageSection from "@/components/PageSection";

export default {
  components: {
    SectionHeading,
    PageSection,
  },
  data() {
    return {
      resources: [
        {
          title: "Having a Baby",
          description:
            "Accessible and sound fertility, pregnancy, labor, birth, and postpartum information.",
          to: "https://havingababy.co/",
        },
        {
          title: "Niijaansinaanik Child and Family Services",
          description:
            "A culture based organization responsive to the holistic needs of all children, youth, and families.",
          to: "https://niijcfs.com/",
        },
        {
          title: "Blossoms Early Learning",
          description:
            "Informative, engaging, and enjoyable classes that aid in building solid and strong foundations for lifelong success.",
          to: "https://www.blossomearlylearning.ca/",
        },
        {
          title: "AIDS",
          description: "AIDS Committee North Bay",
          to: "https://aidsnorthbay.com/",
        },
        {
          title: "LGBTQ",
          description: "The LGBTQ Parenting Network",
          to: "https://lgbtqpn.ca/",
        },
        {
          title: "The Looksee Checklist",
          description:
            "The Looksee Checklist is a simple, easy-to-use developmental tool designed to help monitor a child’s development from 1 month to 6 years of age.",
          to: "https://www.lookseechecklist.com/en/",
        },
        {
          title: "Association of Ontario Midwives",
          description: "Association of Ontario Midwives – Find a Midwife",
          to: "https://www.ontariomidwives.ca/find-midwife",
        },
        {
          title: "National Aboriginal Council of Midwives",
          description: "National Aboriginal Council of Midwives",
          to: "https://indigenousmidwifery.ca/",
        },
        {
          title: "Canadian Association of Midwives",
          description: "Canadian Association of Midwives",
          to: "https://canadianmidwives.org/",
        },
      ],
    };
  },
};
</script>